module.exports = __webpack_public_path__ + "Server-Unknown.TentacleActive.dd0a51b47eaf1f3f15f488db73332db9.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unknown.TentacleActive.png
// module id = 1271
// module chunks = 1